var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.659 9.20686C19.6956 2.92083 13.1782 0 7.79601 0C5.84725 0 3.89849 0.920194 0 0V1.84137C0 10.7041 5.23585 14.73 11.6935 14.73H13.0819C13.3351 14.73 13.5306 14.5039 13.5017 14.2463C13.2254 11.7561 12.2837 10.1595 10.0404 8.2847C8.86667 7.30453 8.96681 6.73826 9.5445 7.06269C12.8865 8.94142 14.8179 11.2684 15.4033 14.8244C15.4948 15.3808 15.5535 15.9667 15.5795 16.5861C15.5891 16.8171 15.775 17 16.0012 17H16.5548H19.5772C19.8381 17 20.0374 16.7611 19.9941 16.4986C19.8564 15.6551 19.633 13.5955 19.659 9.20588V9.20686Z",
    fill: "url(#paint0_linear_404_7769)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_7769",
    x1: 0.000962827,
    y1: 8.5,
    x2: 20.0008,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58BE94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafLogo);
export default __webpack_public_path__ + "static/media/leafLogo.b650d3f63b47aa96146e59bd49b0c74a.svg";
export { ForwardRef as ReactComponent };